import { DATE_FORMAT, TIME_FORMAT } from '../constants';
import moment from 'moment';

export const getDate = (showDate, dueDate) =>
  showDate ? moment(dueDate).format(DATE_FORMAT) : '';

export const getTime = (showTime, hour, minute, period) =>
  showTime
    ? moment(
        `${moment().format(DATE_FORMAT)} ${hour}:${minute} ${period}`,
        DATE_FORMAT + ' ' + TIME_FORMAT
      ).format(TIME_FORMAT)
    : '';
